import { render, staticRenderFns } from "./teacher-dashboard.vue?vue&type=template&id=2a90df30&scoped=true&"
import script from "./teacher-dashboard.vue?vue&type=script&lang=js&"
export * from "./teacher-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./teacher-dashboard.vue?vue&type=style&index=0&id=2a90df30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a90df30",
  null
  
)

export default component.exports